import { rhpToYears } from '../utils/formatter'

export const DATE_VALUES = ['aiReferenceDate']
export const MONETARY_VALUES = [
  'aiCap',
  'aiPremiumAmountSingle',
  'aiPremiumAmountAnnual',
  'aiAdditionalAmount',
  'aiSegregatedFundCumulativeMax',
  'aiMinimumResidualAmount',
]
export const PERCENTAGE_VALUES = [
  'aiSegregatedFundLevelWarranty',
  'aiFundWarrantyPercentage',
  'aiAdditionalAmountDeathInsuredPercentage',
  'aiMinimumBonusValue',
  'aiIntermediaryCosts',
  'aiExitCostsTunnelData',
]

export const YEARS_VALUES = ['aiRedeemTerm', 'aiDurationPayment']

export const SLIDER_PERCENTAGE = ['aiSegregatedFundPercentage', 'aiUnitComponentPercentage']

export const VISIBILITY_RULES = () => {
  let map = new Map()

  const premiumTypeSingle = { key: 'premiumType', value: 1, description: 'Premium type single' }
  const premiumTypeRegular = { key: 'premiumType', value: 2, description: 'Premium type regular' }
  const premiumTypeMixed = { key: 'premiumType', value: 3, description: 'Premium type mixed' }

  const ramoI = { key: 'productType', value: 1, description: 'RamoI' }
  const ramoIII = { key: 'productType', value: 2, description: 'RamoIII' }
  const ramoV = { key: 'productType', value: 4, description: 'RamoI' }
  const multiRamo = { key: 'productType', value: 3, description: 'MultiRamo' }

  map.set('aiPremiumAmountSingle', [premiumTypeSingle, premiumTypeMixed])
  map.set('aiPremiumAmountAnnual', [premiumTypeRegular, premiumTypeMixed])
  map.set('aiSplitPremiumPeriod', [premiumTypeRegular, premiumTypeMixed])
  map.set('aiSegregatedFundCumulativeMax', [ramoI, ramoV, multiRamo])

  map.set('aiSegregatedFundPercentage', [multiRamo])
  map.set('aiUnitComponentPercentage', [multiRamo])
  map.set('aiMultipleUnitComponent', [ramoIII, multiRamo])

  map.set('aiDurationPayment', [premiumTypeRegular, premiumTypeMixed])
  map.set('aiSegregatedFundWarranty', [ramoI, ramoV, multiRamo])
  map.set('aiSegregatedFundLevelWarranty', [ramoI, ramoV, multiRamo])
  map.set('aiSegregatedFundPremiumWarranty', [ramoI, ramoV, multiRamo])

  map.set('aiFundWarrantyPercentage', [ramoIII, multiRamo])
  map.set('aiFundPremiumWarranty', [ramoIII, multiRamo])

  return map
}

export const FIELDS_COMPOSER = () => [
  {
    aiReferenceDate: {
      component: 'default',
    },
    aiInsuranceLifeType: {
      component: 'default',
      isValueOf: 'aiInsuranceLifeTypeValues',
    },
    aiPremiumAmountSingle: {
      component: 'minMax',
    },
    aiPremiumAmountAnnual: {
      component: 'minMax',
    },
    aiSplitPremiumPeriod: {
      component: 'default',
      isValueOf: 'aiSplitPremiumPeriodValues',
      border: true,
    },

    aiIsAdditionalAmount: {
      component: 'radio',
    },
    aiAdditionalAmount: {
      component: 'minMax',
    },
    aiSegregatedFundCumulativeMax: {
      component: 'default',
      border: true,
    },

    aiInvestmentProfile: {
      component: 'default',
      isValueOf: 'aiInvestmentProfileValues',
    },
    aiUnderlyingNumber: {
      component: 'default',
    },
    aiUnderlyingCombinationNumber: {
      component: 'default',
    },
    aiIsSegregatedFundWithProfitFund: {
      component: 'radio',
    },
    aiSegregatedFundPercentage: {
      component: 'CustomSlider',
      marks: { inf: 0, sup: 100 },
      formatter: (val) => (typeof val === 'number' ? val + '%' : ''),
    },
    aiUnitComponentPercentage: {
      component: 'CustomSlider',
      marks: { inf: 0, sup: 100 },
      formatter: (val) => (typeof val === 'number' ? val + '%' : ''),
    },
    aiMultipleUnitComponent: {
      component: 'radio',
      border: true,
    },

    aiTerm: {
      component: 'CustomSlider',
      marks: { inf: 1, sup: 30 },
      formatter: (val) => (val ? rhpToYears(val) : val),
    },
    aiDurationPayment: {
      component: 'minMax',
    },

    aiSegregatedFundWarranty: {
      component: 'inline',
      options: [
        {
          key: 'aiSegregatedFundWarrantyMinimumRate',
          component: 'pill',
        },
        {
          key: 'aiSegregatedFundWarrantySurrender',
          component: 'pill',
        },
        {
          key: 'aiSegregatedFundWarrantyTerm',
          component: 'pill',
          fixedWidth: false,
        },
        {
          key: 'aiSegregatedFundWarrantyWindow',
          component: 'pill',
        },
        {
          key: 'aiSegregatedFundWarrantyOther',
          component: 'pill',
        },
      ],
    },

    aiSegregatedFundLevelWarranty: {
      component: 'default',
    },
    aiSegregatedFundPremiumWarranty: {
      component: 'radio',
    },
    aiFundWarrantyPercentage: {
      component: 'default',
    },
    aiFundPremiumWarranty: {
      border: true,
      component: 'radio',
    },

    aiAdditionalAmountDeathInsuredComponent: {
      component: 'inline',
      valueDict: {
        aiFund: [0, 2],
        aiSegregatedFund: [1, 2],
      },
      options: [
        {
          key: 'aiFund',
          component: 'pill',
        },
        {
          key: 'aiSegregatedFund',
          component: 'pill',
        },
      ],
    },

    aiCap: {
      component: 'default',
    },

    aiAdditionalAmountDeathInsuredPercentage: {
      component: 'minMax',
    },

    aiAdditionalCoverage: {
      component: 'flex',
      badge_classes: ['mandatory', 'optional', 'requiredOptional'],
      enumOptions: [
        {
          key: 'aiAdditionalCoverageDeath',
          component: 'radio',
          border: true,
          isValueOf: 'aiAdditionalCoverageValues',
        },
        {
          key: 'aiAdditionalCoverageHealth',
          component: 'radio',
          border: true,
          isValueOf: 'aiAdditionalCoverageValues',
        },
        {
          key: 'aiAdditionalCoverageOther',
          component: 'radio',
          border: false,
          isValueOf: 'aiAdditionalCoverageValues',
        },
      ],
    },

    aiMinimumBonusValue: {
      component: 'default',
    },

    aiContractOptions: {
      component: 'flex',
      options: [
        {
          key: 'aiContractOptionsAnnuityConversion',
          component: 'radio',
          border: true,
        },
        {
          key: 'aiIsTotalRedeem',
          component: 'radio',
          border: true,
        },
        {
          key: 'aiIsPartialRedeem',
          component: 'radio',
          legend: 'aiMinimumResidualAmount',
          border: true,
        },
        {
          key: 'aiHasReductions',
          component: 'radio',
          border: false,
        },
      ],
    },

    aiRedeemTerm: {
      border: true,
      component: 'default',
    },

    aiExitCostsTunnelData: {
      component: 'table',
      tableFields: ['year', 'value'],
      existsIfTrue: 'aiIsTotalRedeem',
      hideNullValues: true,
    },

    aiIntermediaryCosts: {
      component: 'default',
    },
  },
]
